export const EVENT = {
  ENABLE_EMAIL: 'enable_email',
  DISABLE_EMAIL: 'disable_email',
}

export const NEWSLETTERS_NAMES = {
  goodDeals: 'good_deals',
  sletter: 'sletter',
}
